import(/* webpackMode: "eager" */ "/app/apps/root/app/[locale]/root.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/root/assets/images/hero-1.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/assets/images/hero-2.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/assets/images/hero-3.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/assets/images/hero-4.avif");
;
import(/* webpackMode: "eager" */ "/app/apps/root/assets/images/hero-5.avif");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/BlockSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/FlagsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/HomeHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/HomeInstallPrompt/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/HomePageDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/root/components/MarketingModals/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/layout/src/components/FlashMessages/FlashMessages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/layout/src/components/Page.tsx");
